import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HourglassService } from 'src/app/services/hourglass.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as dayjs from 'dayjs';
import { SQLMonitorComponent } from '../../sql-monitor/sql-monitor.component';

@Component({
  selector: 'app-tab-taskmanager',
  templateUrl: './tab-task-manager.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabTaskManagerComponent implements OnInit {
  @ViewChild(SQLMonitorComponent) sqlMonitor!: SQLMonitorComponent;
  @ViewChild('mergeSearch') mergeSearch!: ElementRef;
  token!: string;
  dropdownSettings: IDropdownSettings = {};
  clientSettings: IDropdownSettings = {};
  dropdownList: any[] = [];
  dropdownClients: any[] = [];
  selectedItems: any[] = [];
  errorMsg = "";
  showModal = "none";
  taskSearch = "";
  taskFilterSearch = "";
  taskStatusFilter = -1;
  allTasks: any[] = [];
  filteredTasks: any[] = [];
  filteredSearchedTasks: any[] = [];
  filteredTargets: any[] = [];
  allClients: any[] = [];
  filteredClients: any[] = [];
  mergeTasks: any[] = [];
  editorForm = {
    targetTask: null,
    targetClientRetained: null,
    clientFilter: null
  };
  testContent: SafeHtml = '';
  targetTask: any = {
    taskName: '',
    taskID: '',
    taskDesc: '',
    categoryName: '',
    clientNames: '',
    clientIDs: '',
    assigneeIDs: '',
    assigneeNames: '',
    lastEntry: ''
  };
  isLoading = false;
  entryCount = 0;
  mergeCount = 0;
  totalCount = 0;
  maxTimeEntry: any = "";
  allAssignees: any[] = [];
  allAssigneesNames: any[] = [];
  uniqueAssignees: any[] = [];
  uniqueAssigneesNames: any[] = [];
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  impersonatedUser: any = this.userID;
  showInstructions = true;

  constructor(
    private hourglassService: HourglassService,
    private sanitizer: DomSanitizer
  ) { }

  //=====================================
  // module init
  //=====================================
  ngOnInit(): void {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    // get the render heights of the card bodies
    const heights: any[] = [
      $('#body_target').height()!.toFixed(),
      $('#body_eligible').height()!.toFixed(),
      $('#body_merged').height()!.toFixed()
    ];

    // get the tallest one and set the height to that value plus a buffer for all 3
    const max = Math.max(...heights)
    $('#body_target,#body_eligible,#body_merged').css('height', (max + 30) + 'px')

    // multiselect dropdown configs (client group and target task)
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 't_name',
      enableCheckAll: false,
      itemsShowLimit: 12,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      maxHeight: 325
    };

    this.clientSettings = {
      singleSelection: true,
      idField: 'ids',
      textField: 'names',
      enableCheckAll: false,
      itemsShowLimit: 12,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      maxHeight: 325

    };

    this.getTaskData();
  }

  //=====================================
  // main data fetch routine
  //=====================================
  getTaskData(): void {
    this.isLoading = true;
    const params = JSON.parse('{"tasksActive":"' + this.taskStatusFilter + '"}');

    this.hourglassService.getTimeEntryUxData('-1', 'tasksmerge', params, this.token).then(r => {
      this.allTasks = r.tasksmerge;
      this.filteredTasks = r.tasksmerge;
      this.filteredTargets = r.tasksmerge;
      this.allClients = this.allTasks.map((obj: { clientids: any, client_names_long: any }) => ({ ids: obj.clientids, names: obj.client_names_long }));
      this.filteredClients = [...new Set(this.allClients.map(obj => JSON.stringify(obj)))].map(str => JSON.parse(str));

      this.filteredClients = this.filteredClients.sort((a, b) => {
        const nameA = a.names.toLowerCase().trim(); // Convert to lowercase for case-insensitive comparison
        const nameB = b.names.toLowerCase().trim();

        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0; // names are the same
      });

      if (this.editorForm.targetClientRetained != null) {
        const value = this.editorForm.targetClientRetained;
        this.editorForm.clientFilter = value;
        this.filterTargets(value, 'filter');
      }
      this.isLoading = false;
    })
  }

  //=====================================
  // client group filter toggle
  //=====================================
  filterTargets(params: any, mode: any): void {
    if (mode == 'filter') {
      const tmp = (Array.isArray(params)) ? params[0] : params;
      this.filteredTargets = this.allTasks.filter(obj => obj.clientids == tmp.ids)
    } else {
      this.filteredTargets = this.allTasks
    }
  }

  //=====================================
  // filter active/inactive/all eligible tasks (deprecated)
  //=====================================
  onTaskFilterChange(params: any): void {
    this.taskFilterSearch = params;
  }

  //=====================================
  // target task selection
  //=====================================
  onItemSelect(item: any, mode: any): void {
    if (mode == 'filter') {

      const key = item.id;
      const task = this.allTasks.find(item => item.id === key);

      this.allAssignees = [];
      this.allAssigneesNames = [];
      this.uniqueAssignees = [];
      this.uniqueAssigneesNames = [];
      this.mergeCount = 0;
      this.totalCount = 0;

      this.targetTask.taskName = task.t_name;
      this.targetTask.taskID = task.id;
      this.targetTask.taskDesc = task.t_description;
      this.targetTask.assigneeIDs = task.assignees.replace(/, /g, ',');
      this.targetTask.assigneeNames = task.assignee_names.replace(/, /g, ',');
      this.targetTask.categoryName = task.category_name;
      this.targetTask.clientIDs = task.clientids;
      this.targetTask.clientNames = task.client_names;
      this.targetTask.lastEntry = dayjs(task.last_entry).format('M/D/YY hh:mmA');
      this.maxTimeEntry = this.targetTask.lastEntry;
      this.entryCount = task.entry_count;
      this.totalCount = task.entry_count;

      const myassignees = this.targetTask.assigneeIDs.split(',');
      const names = this.targetTask.assigneeNames.split(',');

      for (let i = 0; i < myassignees.length; i++) {
        this.allAssignees.push(myassignees[i].trim())
        this.allAssigneesNames.push(names[i].trim())
      }

      this.uniqueAssignees = [...new Set(this.allAssignees)];
      this.uniqueAssigneesNames = [...new Set(this.allAssigneesNames)];

      setTimeout(() => {
        this.filteredTasks = this.allTasks.filter(flttask => (
          flttask.clientids == task.clientids && flttask.id !== key
        ))

        this.filteredSearchedTasks = this.filteredTasks;
        console.log(this.filteredSearchedTasks[0])
      })
      // set the filtered tasks array to only include tasks with the same clients
      // and not the target task itself
      
      
    } else {
      this.targetTask = {
        taskName: '',
        taskID: '',
        taskDesc: '',
        categoryName: '',
        clientNames: '',
        clientIDs: '',
        assigneeIDs: '',
        assigneeNames: '',
        lastEntry: ''
      };
      this.allAssignees = [];
      this.uniqueAssignees = [];
      this.uniqueAssigneesNames = [];
      this.entryCount = 0;
      this.totalCount = 0;
    }
    setTimeout(() => {
      $('#mergeSearch').trigger('focus')
    })
  }

  //=====================================
  // format date (N America for now - dynamic later)
  //=====================================
  formatDate(dt: any): string {
    return dayjs(dt).format('M/D/YY hh:mmA')
  }

  //=====================================
  // change a merge target to the target task
  //=====================================
  swapTarget(params: any): void {
    const retainedSearch = this.taskSearch;
    const test = confirm('Are you sure you want to make Task ID ' + params + ' the Target Task?');
    if (test) {
      const newtarget = this.allTasks.find(obj => obj.id == params);
      const tomerge = this.allTasks.find(obj => obj.id == this.targetTask.taskID);
      const del = this.mergeTasks.findIndex(obj => obj == newtarget.id);

      $('.form-check-input').prop('checked', false);
      
      this.mergeTasks.splice(del, 1);
      //this.mergeTasks.push(tomerge.id);
      this.onItemSelect(newtarget, 'filter'); // reset the target task
      this.onTaskToggle(tomerge.id, { target: { checked: true } });
      

      setTimeout(() => {
        this.taskSearch = retainedSearch;
        this.calculateMergeData();
        if(this.taskSearch !== '')
          this.searchTasks();

      })
    }
  }

  //=====================================
  // eligible merge task click
  //=====================================
  onTaskToggle(taskid: number, event: any): void {
    if (event.target.checked) {
      this.mergeTasks.push(taskid);
    } else {
      const idx = this.mergeTasks.findIndex(task => task == taskid);
      this.mergeTasks.splice(idx, 1);
    }
    this.calculateMergeData();
  }

  //=====================================
  // calculates stats for the merged task pane
  //=====================================
  calculateMergeData(): void {
    this.uniqueAssignees = [];
    this.uniqueAssigneesNames = [];
    this.mergeCount = 0;

    const t = this.mergeTasks;
    this.allAssignees = this.targetTask.assigneeIDs.split(',');
    this.allAssigneesNames = this.targetTask.assigneeNames.split(',');


    if (t.length > 0) {
      // loop through selected merge tasks
      t.forEach((val, idx) => {
        const record = this.allTasks.find(mytask => mytask.id == val);
        this.mergeCount += parseInt(record.entry_count);

        $('#t_' + val).prop('checked', true);

        // handle assignees
        const a = record.assignees.split(',');
        const anames = record.assignee_names.split(',');

        for (let i = 0; i < a.length; i++) {
          this.allAssignees.push(a[i].trim())
          this.allAssigneesNames.push(anames[i].trim())
        }
      })
    }
    this.uniqueAssignees = [...new Set(this.allAssignees)];
    this.uniqueAssigneesNames = [...new Set(this.allAssigneesNames)];
    this.totalCount = this.entryCount + this.mergeCount;
  }
  //=====================================
  // active, inactive all flag on target task filter
  //=====================================
  onTaskStatusFilterChange(): void {
    if (this.taskStatusFilter == -1)
      this.filteredTasks = this.allTasks;
    else
      this.filteredTasks = this.allTasks.filter(task => task.active_flag == this.taskStatusFilter);
  }

  //=====================================
  // gets constantly polled since it is bound to [innerHTML]
  //=====================================
  getTaskDetail(task: number) {
    const mytask = this.allTasks.find(mytask => mytask.id == task);
    const taskRecord = [
      '<div class="my-1 d-none"><strong>ID: </strong> ', mytask.id, '</div>',
      '<div class="my-1"><strong>Name:</strong> ', mytask.t_name, '</div>'
    ];
    if (mytask.t_description != '')
      taskRecord.push(
        '<div class="my-1"><strong>Description:</strong> ', mytask.t_description, '</div>'
      )

    taskRecord.push(
      '<div class="my-1"><strong>Category:</strong> ', mytask.category_name, '</div>',
      '<div class="my-1"><strong>Client(s):</strong> ', mytask.client_names, '</div>',
      '<div class="my-1"><strong>Assignee(s):</strong> ', mytask.assignee_names, '</div>',
      '<div class="my-1"><strong>Time Entries:</strong> ', mytask.entry_count, '</div>',
      '<div class="my-1"><strong>Last Entry:</strong> ', dayjs(mytask.last_entry).format('M/D/YY hh:mmA'), '</div>'
    )
    const content = this.getSafeHTML(taskRecord.join(''));
    this.targetTask.totalCount = mytask.entry_count;
    return content;
  }

  //=====================================
  // sanitize the html built in getTaskDetail()
  //=====================================
  getSafeHTML(content: string): SafeHtml {
    const ret = this.sanitizer.bypassSecurityTrustHtml(content);
    return ret;
  }

  //=====================================
  // search field - return tasks that contain the search string,
  // have the same clients as the target task, and are not the target task
  //=====================================
  searchTasks(obj: any = null): void {
    let fltTasks: any[] = [];

    fltTasks = this.filteredTasks.filter(task => (
      task.t_name.toLowerCase().indexOf(this.taskSearch.toLowerCase()) > -1
      && task.clientids == this.targetTask.clientIDs
      && task.id != this.targetTask.taskID
    ))

    this.filteredSearchedTasks = fltTasks;
  }

  //=====================================
  // clear button handler: reset the screen
  //=====================================
  clearMerge(): void {
    this.isLoading = true;
    this.targetTask = {
      taskName: '',
      taskID: '',
      taskDesc: '',
      categoryName: '',
      clientNames: '',
      clientIDs: '',
      assigneeIDs: '',
      assigneeNames: '',
      lastEntry: ''
    }
    this.editorForm.clientFilter = this.editorForm.targetClientRetained;
    this.editorForm.targetTask = null;
    this.filteredTasks = this.allTasks;
    this.filteredSearchedTasks = [];

    this.mergeTasks = [];
    this.entryCount = 0;
    this.mergeCount = 0;
    this.totalCount = 0;
    this.taskSearch = "";
    this.isLoading = false;
    this.allAssignees = [];
    this.allAssigneesNames = [];
    this.uniqueAssignees = [];
    this.uniqueAssigneesNames = [];
  }

  //=====================================
  // save the merge: validate, save, display sql
  //=====================================
  saveMerge(): void {
    if (this.editorForm.targetTask == null) {
      this.errorMsg = 'Please select a target task';
      setTimeout(() => this.errorMsg = '', 5000);
      return;
    }

    if (this.mergeTasks.length == 0) {
      this.errorMsg = 'Please select at least one task to merge';
      setTimeout(() => this.errorMsg = '', 5000);
      return;
    }

    const test = confirm('Are you sure you want to commit this task merge request?');
    if (test) {
      const obj = {
        targetTask: this.targetTask,
        consolidatedTasks: this.mergeTasks.join(','),
        assignees: this.uniqueAssignees.join(',')
      }


      this.hourglassService.saveTaskMerge(obj, this.token).then(r => {
        this.sqlMonitor.updateSQLMonitor("Last Batch (Refresh in 10s):\n\n" + r);
        if (this.editorForm.clientFilter != null)
          this.editorForm.targetClientRetained = this.editorForm.clientFilter;
        this.clearMerge();
        this.getTaskData();

        setTimeout(() => {
          this.sqlMonitor.updateSQLMonitor('Please complete the form and click save to continue.');
        }, 10000)
      })
    }
  }

  //=====================================
  // generic clear error function
  //=====================================
  clearError(): void {
    setTimeout(() => {
      this.errorMsg = ""
    }, 3500);
  }

  //=====================================
  // used for ngFor tracking
  //=====================================
  trackByFn(index: any, record: any) {
    return record.id
  }
}
